const Reducer = (state, action) => {
  switch (action.type) {
    case 'FORM_REFRESH':
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        data: false,
        step: false,
        message: '',
      };
    case 'FORM_LOADING':
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: '',
      };

    case 'FORM_POST_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        data: false,
        message: action.payload.message,
      };
    case 'FORM_POST_SUCCESS':
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action?.payload?.data?.data,
        step: action?.payload?.step,
        message: action?.payload?.message || 'Form Post Successfully.',
      };
    case 'CHANGE_FORM_STATE':
      return {
        ...state,
        ...action.payload,
      };
    case 'CHANGE_FORM_VALUE':
      return {
        ...state,
        values: {
          ...state.values,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default Reducer;
